import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Mail, Phone, MapPin, ArrowRight } from "lucide-react";
import { CONTACT_EMAIL, WHATSAPP_DISPLAY, WHATSAPP_NUMBER, LOGO_URL } from "../../lib/api";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-navy text-white/80" data-testid="site-footer">
      <div className="container-site pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-navy border border-white/10 rounded-md p-1.5 h-11 w-11 flex items-center justify-center">
                <img src={LOGO_URL} alt="Otel Pro" className="h-7 w-auto" />
              </div>
              <div className="heading-serif text-white text-lg font-semibold">Otel Pro</div>
            </div>
            <p className="text-sm leading-relaxed text-white/65">
              {t("tagline")} — A'dan Z'ye ekipman tedariki ve profesyonel rehberlik.
            </p>
            <p className="accent-script text-gold text-xl mt-4">Yanınızdayız.</p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-[0.14em]">{t("footer.explore")}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/kategoriler" className="hover:text-gold transition-colors">{t("nav.categories")}</Link></li>
              <li><Link to="/acilis-rehberi" className="hover:text-gold transition-colors">{t("nav.guide")}</Link></li>
              <li><Link to="/oda-tipleri" className="hover:text-gold transition-colors">{t("nav.rooms")}</Link></li>
              <li><Link to="/hesaplama" className="hover:text-gold transition-colors">{t("nav.calculator")}</Link></li>
              <li><Link to="/karsilastirma" className="hover:text-gold transition-colors">{t("nav.compare")}</Link></li>
              <li><Link to="/blog" className="hover:text-gold transition-colors">{t("nav.blog")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-[0.14em]">{t("footer.corporate")}</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/hakkimizda" className="hover:text-gold transition-colors">{t("footer.about")}</Link></li>
              <li><Link to="/iletisim" className="hover:text-gold transition-colors">{t("footer.contact")}</Link></li>
              <li><Link to="/iletisim" className="hover:text-gold transition-colors">{t("footer.fast_quote")}</Link></li>
              <li><Link to="/hakkimizda" className="hover:text-gold transition-colors">{t("footer.refs")}</Link></li>
              <li><Link to="/kvkk" className="hover:text-gold transition-colors" data-testid="footer-kvkk">KVKK & Çerez Politikası</Link></li>
              <li><Link to="/admin/login" className="hover:text-gold transition-colors">{t("footer.admin_login")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-[0.14em]">{t("footer.contact")}</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-2 items-start">
                <Phone size={14} className="text-gold mt-0.5" />
                <a href={`tel:+${WHATSAPP_NUMBER}`} className="hover:text-gold transition-colors">
                  {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li className="flex gap-2 items-start">
                <Mail size={14} className="text-gold mt-0.5" />
                <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-gold transition-colors">{CONTACT_EMAIL}</a>
              </li>
              <li className="flex gap-2 items-start">
                <MapPin size={14} className="text-gold mt-0.5" />
                <span>{t("footer.service_area")}</span>
              </li>
            </ul>
            <Link to="/iletisim" className="inline-flex items-center gap-1 text-gold hover:text-[#c49d58] text-sm mt-5 link-underline" data-testid="footer-quote-link">
              {t("cta.free_consultation")} <ArrowRight size={14} />
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Otel Pro. {t("footer.rights")}</p>
          <p className="tracking-widest uppercase">{t("footer.tagline_bottom")}</p>
        </div>
      </div>
    </footer>
  );
}
